import { type ComponentProps } from "react";

// Link interno vira <Link> do router (navegação sem reload); externo continua
// <a> com target="_blank".
import { Link } from "react-router-dom";

import { useLocaleCode } from "../lib/i18n.jsx";
import { aplicarTokens } from "../lib/runtime-config.js";

export default function Anchor({ href: rawHref = "", children: rawChildren, ...rest }: ComponentProps<"a">) {
  // Um link para o sandbox escrito com token (`[{SANDBOX_MOTOR_JS}/motor.html](…)`)
  // precisa do valor real tanto no destino quanto no texto.
  const locale = useLocaleCode();
  const href = aplicarTokens(rawHref, locale);
  const children = typeof rawChildren === "string" ? aplicarTokens(rawChildren, locale) : rawChildren;
  const isInternal = href.startsWith("/") && !href.startsWith("//");
  if (isInternal)
    return (
      <Link to={href} {...rest}>
        {children}
      </Link>
    );
  const isExternal = /^https?:/.test(href);
  return (
    <a href={href} {...(isExternal ? { target: "_blank", rel: "noreferrer" } : {})} {...rest}>
      {children}
    </a>
  );
}
